import { CommentListService } from '@go-modules/services/comment-list/comment-list.service';
import { FeedbackSessionService } from '@go-modules/services/feedback-session/feedback-session.service';

/* @ngInject */
export const FeedbackSessionCommentSyncEventViewer = function (
	feedbackSettings,
	PlayerSync,
	ngxCommentListService: CommentListService,
	ngxFeedbackSessionService: FeedbackSessionService
) {
	const vm = this;
	vm.feedbackSettings = feedbackSettings;
	vm.selectedItem = null;

	vm.$onInit = () => {
		ngxCommentListService.filterOutSyncEventComments = false;
		ngxCommentListService.setComments(vm.mainController.sessionFeedback.getComments()
			.filter((comment) => {
				return vm.filterSyncEventTypes(comment);
			}));
	};

	/**
	 * Filter out comments that aren't associated with a sync event
	 *
	 * @returns {boolean}
	 */
	vm.filterSyncEventTypes = (comment) => {
		return comment.isSyncEventType();
	};

	/**
	 * Whether there sync event comments
	 *
	 * @returns {boolean}
	 */
	vm.hasSyncEventComments = () => {
		return ngxCommentListService.currentComments
			.filter((comment) => {
				return vm.filterSyncEventTypes(comment);
			}).length > 0;
	};

	/**
	 * Close this viewer and update playerSync
	 */
	vm.done = () => {
		ngxFeedbackSessionService.togglePanel(true);
		vm.mainController.playerSync.setMode(PlayerSync.MODE.PLAYBACK);
	};

	/**
	 * Close this viewer but don't update playerSync
	 */
	 vm.close = () => {
		ngxFeedbackSessionService.togglePanel(false);
	};
};
